import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "@/assets/js/models/helpers/JsonMapper";
var _attributes = /*#__PURE__*/new WeakMap();
export default class ECommerceSdkField extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [ECommerceSdkField.type_attribute_name]: null,
      [ECommerceSdkField.name_attribute_name]: null,
      [ECommerceSdkField.title_attribute_name]: null,
      [ECommerceSdkField.placeholder_attribute_name]: null,
      [ECommerceSdkField.content_attribute_name]: null,
      [ECommerceSdkField.show_title_attribute_name]: false,
      [ECommerceSdkField.options_attribute_name]: []
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getTypeAttributeName() {
    return ECommerceSdkField.type_attribute_name;
  }
  static getNameAttributeName() {
    return ECommerceSdkField.name_attribute_name;
  }
  static getTitleAttributeName() {
    return ECommerceSdkField.title_attribute_name;
  }
  static getPlaceholderAttributeName() {
    return ECommerceSdkField.placeholder_attribute_name;
  }
  static getOptionsAttributeName() {
    return ECommerceSdkField.options_attribute_name;
  }
  static getShowTitleAttributeName() {
    return ECommerceSdkField.show_title_attribute_name;
  }
  static getContentAttributeName() {
    return ECommerceSdkField.content_attribute_name;
  }
  getShowTitle() {
    return this.getAttribute(ECommerceSdkField.getShowTitleAttributeName());
  }
  getTitle() {
    return this.getAttribute(ECommerceSdkField.getTitleAttributeName());
  }
  getPlaceholder() {
    return this.getAttribute(ECommerceSdkField.getPlaceholderAttributeName());
  }
  getOptions() {
    return this.getAttribute(ECommerceSdkField.getOptionsAttributeName());
  }
  getName() {
    return this.getAttribute(ECommerceSdkField.getNameAttributeName());
  }
  getType() {
    return this.getAttribute(ECommerceSdkField.getTypeAttributeName());
  }
  getFieldType() {
    return this.getType() === 'password' ? 'password' : 'text';
  }
  getContent() {
    return this.getAttribute(ECommerceSdkField.getContentAttributeName());
  }
  getComponent() {
    switch (this.getType()) {
      case 'radio':
        return 'VRadioMcn';
      case 'checkbox':
        return 'VCheckboxMcn';
      case 'textarea':
        return 'VTextarea';
      default:
        return 'VTextField';
    }
  }
}
_defineProperty(ECommerceSdkField, "type_attribute_name", 'type');
_defineProperty(ECommerceSdkField, "name_attribute_name", 'name');
_defineProperty(ECommerceSdkField, "title_attribute_name", 'title');
_defineProperty(ECommerceSdkField, "placeholder_attribute_name", 'placeholder');
_defineProperty(ECommerceSdkField, "options_attribute_name", 'options');
_defineProperty(ECommerceSdkField, "show_title_attribute_name", 'show_title');
_defineProperty(ECommerceSdkField, "content_attribute_name", 'content');